import UiAction from "./index";

// if this is for info post third sub page form
$(() => {
  if ($("#third_sub_page_form").length > 0) {
    const subPageUiAction = new UiAction(
      "#sub_page_ui_actions",
      "#sub_page_ui_action_radio_buttons",
      "#sub_page_ui_action_items",
      {
        isSubPageRequired: false,
        isSubPage: true,
      },
      {
        hasSubPage: true,
        hasCallToAction: true,
      }
    );
    subPageUiAction.attach();
  }
});
